import { EmailWithPhoneNumberDtoIn } from '../../generated';
import { fromPhoneToGenerated } from './phoneNumber.parser';

export const fromEmailWithPhoneToGenerated = (email: string, phone: string): EmailWithPhoneNumberDtoIn => {
  return {
    email: email,
    phoneNumber: fromPhoneToGenerated(phone)
  };
};
